import { style } from 'typestyle'
export const mr48 = style({ marginRight: '48px' })
